import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertBox } from '@/common/AlertBox';
import { InfoSectionContainer } from '@/common/InfoSection';
import { TabsBar } from '@/common/TabsBar';
import { SettingsLoginInfo } from '@/settings/SettingsLoginInfo';
import { FormTitle, PageContent, PageHeader } from '@/settings/settingsStyles';
import { getMemberSettingsTabs } from '@/settings/tabData';
import { Title } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/settings/',
)({
  component: SettingsRoute,
});

function SettingsRoute() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    currentPassword: '',
    accountEmail: 'savannahghowell@gmail.com',
    newPassword: '',
    repeatPassword: '',
  });
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const handleInputChange = (field: string, value: string | boolean) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSaveChanges = () => {
    console.log('Saving changes:', formData);
    // TODO: Add actual API call to save data
    setShowSuccessAlert(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <PageContent>
      {showSuccessAlert && (
        <AlertBox variant="success">
          {/* Translation Needed */}
          Changes saved.
        </AlertBox>
      )}
      <PageHeader>
        {/* Translation Needed */}
        <Title>Account Settings</Title>
      </PageHeader>

      <div style={{ marginBottom: 11 }}>
        <TabsBar
          tabs={getMemberSettingsTabs(t)}
          base={`/members/${Route.useParams().memberId}/settings`}
          selected="/"
        />
      </div>
      <InfoSectionContainer>
        <FormTitle>{t('wbs.login-information')}</FormTitle>
        <SettingsLoginInfo
          formData={formData}
          onInputChange={handleInputChange}
          onSaveChanges={handleSaveChanges}
        />
      </InfoSectionContainer>
    </PageContent>
  );
}
